function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "AppRating_svg__a",
  d: "M23.917 8.294a1.332 1.332 0 00-1.25-.87h-6.96L13.249.868A1.334 1.334 0 0012 .003a1.334 1.334 0 00-1.25.868L8.294 7.424H1.333a1.333 1.333 0 00-1.25.871 1.333 1.333 0 00.383 1.474l5.812 4.982-2.5 7.5a1.333 1.333 0 00.477 1.5 1.333 1.333 0 001.576 0L12 19.222l6.168 4.523a1.334 1.334 0 001.575 0 1.334 1.334 0 00.478-1.5l-2.5-7.5 5.811-4.982a1.332 1.332 0 00.385-1.469zm-7.169 5.318a1.5 1.5 0 00-.448 1.613l2.332 7-5.744-4.213a1.5 1.5 0 00-1.774 0l-5.747 4.213 2.334-7a1.5 1.5 0 00-.447-1.614L1.785 8.924h6.509a1.5 1.5 0 001.4-.973L12 1.81l2.3 6.141a1.5 1.5 0 001.4.973h6.508z"
});

function SvgAppRating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.997 24.01"
  }, props), _ref, _ref2);
}

export default SvgAppRating;